import React, {useState} from 'react';
import { useNavigate } from "react-router-dom";
import RibbonNav from "../RibbonNav";
import '../../css/aboutStylings/AboutPageStyling.css';
import ContactEntryComponent from "./ContactEntryComponent";
import VineAnimation from '../reusableComponents/VineAnimation';

import storyImage from '../../images/aboutPageImage1.png';

const AboutPage = () => {

    const navigate = useNavigate();
    const [contactUsActive, setContactUsActive] = useState(false);

    return (
        <div className="about-page">
            {/*<div className={`ribbon-container`}>*/}
            {/*    <RibbonNav pageName="About" />*/}
            {/*</div>*/}

            <div className="about-page-content">
                {/* Hero Section */}
                <section className="about-hero">
                    <RibbonNav pageName="About" />
                    <div className="about-hero-content">
                        <h1 className="about-hero-title">Growing Dreams, One Garden at a Time</h1>
                        <p className="about-hero-subtitle">
                            We believe every space has the potential to bloom into something beautiful and nourishing.
                        </p>
                    </div>
                </section>

                {/* Mission Section */}
                <section className="about-mission">
                    <div className="about-container">
                        <div className="about-section-header">
                            <h2 className="about-section-title">Our Mission</h2>
                            <div className="about-title-divider"></div>
                        </div>
                        <div className="about-mission-content">
                            <div className="about-mission-text">
                                <p className="about-large-text">
                                    We make gardening simple, joyful, and doable for everyone. Whether you have got a
                                    windowsill or a backyard, we believe you deserve the tools and support to grow
                                    something beautiful.
                                </p>
                                <p>
                                    We’re not just about plants—we’re about people. Gardening connects us to nature,
                                    to each other, and to ourselves. Whether you are a seasoned grower or just curious
                                    about where to start, we’re here to guide, inspire, and cheer you on.
                                </p>
                            </div>
                            <div className="about-mission-visual">
                                <div className="about-decorative-box">
                                    <div className="about-plant-icon">🌱</div>
                                    <h3>Cultivating Community</h3>
                                    <p>Growth is better when it’s shared.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Values Section */}
                <section className="about-values">
                    <div className="about-container">
                        <div className="about-section-header">
                            <h2 className="about-section-title">What We Stand For</h2>
                            <div className="about-title-divider"></div>
                        </div>
                        <div className="about-values-grid">
                            <div className="about-value-card">
                                <div className="about-value-icon">🌿</div>
                                <h3>Sustainability</h3>
                                <p>We champion eco-friendly choices that care for the earth while helping your garden thrive.</p>
                            </div>
                            <div className="about-value-card">
                                <div className="about-value-icon">🎓</div>
                                <h3>Education</h3>
                                <p>We share what we know and learn together—because every gardener starts somewhere.</p>
                            </div>
                            <div className="about-value-card">
                                <div className="about-value-icon">🤝</div>
                                <h3>Community</h3>
                                <p>We connect growers of all kinds, from balcony herb lovers to backyard veggie pros.</p>
                            </div>
                            <div className="about-value-card">
                                <div className="about-value-icon">💚</div>
                                <h3>Wellness</h3>
                                <p>We believe gardening is good for the soul—and the science backs us up.</p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Story Section */}
                <section className="about-story">
                    <div className="about-container">
                        <div className="about-story-content">
                            <div className="about-story-text">
                                <div className="about-section-header">
                                    <h2 className="about-section-title">Our Story</h2>
                                    <div className="about-title-divider"></div>
                                </div>
                                <p>
                                    It didn’t start with a business plan—it started with dirt under our nails and a shared question:
                                    “Why isn’t gardening easier for everyone?”
                                    What began as weekend chats over coffee and compost turned into something bigger: a tool built for real people, real spaces, and real growth.

                                </p>
                                <p>
                                    From sunlit balconies to shaded corners of backyard plots, we’ve watched gardens
                                    come alive with just the right mix of guidance, encouragement, and care. Every
                                    feature we design and every tip we share is grounded in hands-on experience and a
                                    deep love for helping others grow—plants, yes, but also confidence, connection,
                                    and joy
                                </p>
                                <div className="about-story-stats">
                                    <div className="about-stat">
                                        <span className="about-stat-number">100+</span>
                                        <span className="about-stat-label">Gardens Designed</span>
                                    </div>
                                    <div className="about-stat">
                                        <span className="about-stat-number">20+</span>
                                        <span className="about-stat-label">Happy Gardeners</span>
                                    </div>
                                    <div className="about-stat">
                                        <span className="about-stat-number">50+</span>
                                        <span className="about-stat-label">Plant Varieties</span>
                                    </div>
                                </div>
                            </div>
                            <div className="about-story-visual">
                                <div className="about-image-placeholder">
                                    <div className="about-placeholder-content">
                                        <img src={storyImage} alt={"Story picture"} className={'about-page-image'}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Team Section */}
                {/*<section className="about-team">*/}
                {/*    <div className="about-container">*/}
                {/*        <div className="about-section-header">*/}
                {/*            <h2 className="about-section-title">Meet the Team</h2>*/}
                {/*            <div className="about-title-divider"></div>*/}
                {/*            <p className="about-section-subtitle">*/}
                {/*                The passionate gardeners and creators behind your growing success*/}
                {/*            </p>*/}
                {/*        </div>*/}
                {/*        <div className="about-team-grid">*/}
                {/*            <div className="about-team-member">*/}
                {/*                <div className="about-member-photo">*/}
                {/*                    <span className="about-photo-placeholder">👩‍🌾</span>*/}
                {/*                </div>*/}
                {/*                <h3>Sarah Green</h3>*/}
                {/*                <p className="about-member-role">Lead Garden Designer</p>*/}
                {/*                <p className="about-member-bio">*/}
                {/*                    With 15 years in landscape design, Sarah brings expertise in sustainable gardening practices.*/}
                {/*                </p>*/}
                {/*            </div>*/}
                {/*            <div className="about-team-member">*/}
                {/*                <div className="about-member-photo">*/}
                {/*                    <span className="about-photo-placeholder">👨‍💻</span>*/}
                {/*                </div>*/}
                {/*                <h3>Mike Chen</h3>*/}
                {/*                <p className="about-member-role">Tech Lead</p>*/}
                {/*                <p className="about-member-bio">*/}
                {/*                    A developer who codes by day and tends to his rooftop garden by evening.*/}
                {/*                </p>*/}
                {/*            </div>*/}
                {/*            <div className="about-team-member">*/}
                {/*                <div className="about-member-photo">*/}
                {/*                    <span className="about-photo-placeholder">👩‍🔬</span>*/}
                {/*                </div>*/}
                {/*                <h3>Dr. Emma Rodriguez</h3>*/}
                {/*                <p className="about-member-role">Plant Specialist</p>*/}
                {/*                <p className="about-member-bio">*/}
                {/*                    Botanist and soil scientist dedicated to helping plants and people thrive together.*/}
                {/*                </p>*/}
                {/*            </div>*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</section>*/}

                {/* Contact CTA */}
                <section className="about-contact-cta">
                    <div className="about-container">
                        <div className="about-cta-content">
                            <h2>Ready to Grow With Us?</h2>
                            <p>
                                Got questions, ideas, or a garden win you’re proud of? We would love to hear from you.
                                📬 Send us a note at
                                <span className={`email-contact`}> plantedgardendesigner@gmail.com</span>
                            </p>
                            <div className="about-cta-buttons">
                                <button className="about-btn-primary" onClick={() => setContactUsActive(true)}>
                                    Get in Touch
                                </button>
                                <button className="about-btn-secondary" onClick={() => navigate('/in-ground-layout-page')}>
                                    Start Gardening
                                </button>
                            </div>

                            {contactUsActive && (
                                <ContactEntryComponent messageSent={() => setContactUsActive(false)} />
                            )}
                        </div>
                    </div>
                </section>
            </div>

            <VineAnimation
                animationInterval={15000}
                enableMobileVersion={true}
                mobileBreakpoint={768}
                vineOpacity={0.5}
            />
        </div>
    );
};

export default AboutPage;